import { strictObjectAccess } from '../dependencies';

export const Languages = strictObjectAccess({
    CS: 'cs',
});
